export const ENV = process.env.REACT_APP_ENV;
export const GTM_ID = process.env.REACT_APP_GTM_ID